/**
 * 🚀 ELEMENT CONTROLS 2025
 * 
 * Controls für jedes Element (Delete, Reorder, Settings, etc.)
 * - Delete Button (mit Bestätigungs-Modal)
 * - Move Up/Down Buttons (Reorder)
 * - Settings Button (öffnet Sidebar)
 * - Nur im Edit Mode sichtbar
 */

import React, { useState } from 'react';
import DeleteElementModal from './DeleteElementModal';
import './ElementControls.css';

function ElementControls({ 
    onDelete, 
    onMoveUp, 
    onMoveDown, 
    canMoveUp = false, 
    canMoveDown = false, 
    onSettings, 
    element,
    isHorizontalLayout = false, // ✅ Flag ob Elemente horizontal angeordnet sind
    depth = 0, // ✅ NEU: Nesting depth (0 = Top-Level, 1 = Grid-Cell, 2+ = zu tief)
    currentlyEditingElementId = null, // ✅ Global editing state
    isBeingEdited = false // ✅ Ob DIESES Element gerade bearbeitet wird
}) {
    // ✅ State für Delete Modal
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    
    // ✅ Bei horizontaler Anordnung: Links/Rechts Pfeile
    // ✅ Bei vertikaler Anordnung: Oben/Unten Pfeile (default)
    const moveUpIcon = isHorizontalLayout ? 'fa-arrow-left' : 'fa-arrow-up';
    const moveDownIcon = isHorizontalLayout ? 'fa-arrow-right' : 'fa-arrow-down';
    const moveUpTitle = isHorizontalLayout ? 'Move Left' : 'Move Up';
    const moveDownTitle = isHorizontalLayout ? 'Move Right' : 'Move Down';
    
    // ✅ Zeige Controls nur wenn:
    // 1. Kein anderes Element bearbeitet wird ODER
    // 2. Dieses Element selbst bearbeitet wird
    const shouldShowControls = !currentlyEditingElementId || isBeingEdited;
    
    return (
        <>
            {/* 🔄 Reorder Controls - IMMER angezeigt, auch wenn disabled */}
            <div 
                className={`element-controls element-controls-reorder ${isHorizontalLayout ? 'horizontal-layout' : ''} ${!shouldShowControls ? 'force-hidden' : ''}`}
                style={{
                    // ✅ Force hide wenn anderes Element bearbeitet wird
                    visibility: shouldShowControls ? undefined : 'hidden !important',
                    opacity: shouldShowControls ? undefined : '0 !important'
                }}
            >
                {/* Move Up/Left Button - IMMER angezeigt */}
                <button
                    className={`element-control-btn element-control-move-up ${!canMoveUp ? 'disabled' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canMoveUp) {
                            onMoveUp();
                        }
                    }}
                    title={canMoveUp ? moveUpTitle : `Cannot ${moveUpTitle.toLowerCase()}`}
                    disabled={!canMoveUp}
                    style={{
                        opacity: canMoveUp ? 1 : 0.3,
                        cursor: canMoveUp ? 'pointer' : 'not-allowed'
                    }}
                >
                    <i className={`fas ${moveUpIcon}`}></i>
                </button>
                
                {/* Move Down/Right Button - IMMER angezeigt */}
                <button
                    className={`element-control-btn element-control-move-down ${!canMoveDown ? 'disabled' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canMoveDown) {
                            onMoveDown();
                        }
                    }}
                    title={canMoveDown ? moveDownTitle : `Cannot ${moveDownTitle.toLowerCase()}`}
                    disabled={!canMoveDown}
                    style={{
                        opacity: canMoveDown ? 1 : 0.3,
                        cursor: canMoveDown ? 'pointer' : 'not-allowed'
                    }}
                >
                    <i className={`fas ${moveDownIcon}`}></i>
                </button>
            </div>
            
            {/* 🗑️ Delete Control - Rechts oben */}
            <div 
                className={`element-controls element-controls-delete ${!shouldShowControls ? 'force-hidden' : ''}`}
                style={{
                    // ✅ Force hide wenn anderes Element bearbeitet wird
                    visibility: shouldShowControls ? undefined : 'hidden !important',
                    opacity: shouldShowControls ? undefined : '0 !important'
                }}
            >
                <button
                    className="element-control-btn element-control-delete"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowDeleteModal(true); // ✅ Öffnet Modal statt direktem Delete
                    }}
                    title="Delete Element"
                >
                    <i className="fas fa-trash-alt"></i>
                </button>
            </div>
            
            {/* 🗑️ Delete Modal */}
            <DeleteElementModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={() => {
                    onDelete();
                    setShowDeleteModal(false);
                }}
                elementType={element?.type || 'element'}
            />
        </>
    );
}

export default ElementControls;

